import { ReleaseStatusKey } from '../../model/release-status/release-status';
import { GroupComplianceMode } from '../model/group-compliance-mode';

export function buildRequestOptions(mode: GroupComplianceMode): {
  params: { t: string } | { releaseStatus: ReleaseStatusKey; t: string };
} {
  // Use timestamp (t) to avoid getting old (cached) data from IF-Proxy
  const httpParams = mode.getReleaseStatus().toHttpParam();
  const t = new Date().getTime().toString();

  if ('releaseStatus' in httpParams && httpParams.releaseStatus !== undefined) {
    return { params: { releaseStatus: httpParams.releaseStatus, t } };
  }
  return { params: { t } };
}
